import { baseURL } from "../../../api"
import { Character } from "../../../types"

type Props = {
    character: Character,
    displayHS?: boolean,
    size?: number,
}
const CharThumb: React.FC<Props> = (props) => {
    return (
        <>
            <div className="char-thumbnail"
                style={{
                    backgroundImage: `url(${baseURL}/${props.character.texture.img})`,
                    width: `${props.size ?? 80}px`,
                    height: `${props.size ?? 80}px`,
                    borderRadius: `${(props.size ?? 80) / 2}px`,
                }}
            >

                {props.displayHS && <HealthSanity character={props.character} />}

            </div>
        </>
    )
}
export default CharThumb

type HealthSanityProps = {
    character: Character,
    displayHS?: boolean
}
const HealthSanity: React.FC<HealthSanityProps> = (props) => {
    return (
        <>
            <div className="subicon left" style={{ backgroundColor: "#400000"}}>
                <span style={{color: "rgba(255, 0, 0, 0.5)"}}>
                    {props.character.stats.health}
                </span>
            </div>

            <div className="subicon right" style={{ backgroundColor: "#1a237e" }}>
                <span style={{color: "rgba(255, 255, 255, 0.25)"}}>
                    {props.character.stats.sanity}
                </span>
            </div>
        </>
    )
}